<template>

  <div class="relative pt-10 pb-6 text-white bg-lifeboost-blue-dark lg:pt-20 lg:pb-14">
    <!--footer top-->
    <div
      class="max-w-screen-2xl w-full mx-auto px-5 lg:px-14 xl:px-20 2xl:px-12 pb-3.5 md:pb-4 flex flex-wrap justify-between">
      <div
        class="flex flex-wrap justify-center w-64 mx-auto menu-nav-footer md:w-full lg:w-8/12 md:mx-0 lg:justify-end md:space-x-14 lg:space-x-9 xl:space-x-14 2xl:space-x-24 pb-9 lg:order-last">


        <div class="w-full py-5 border-b border-gray-400 md:w-auto md:py-0 md:border-0">

          <h3 @click="toggleAccordion('shop')"
            class="flex items-center justify-between text-base cursor-pointer lg:text-lg font-ww-medium md:cursor-default md:pb-6 accordion-button">
            Shop
            <svg role="presentation" data-acco-button="shop" class="block md:hidden" xmlns="http://www.w3.org/2000/svg"
              width="6" height="4" viewBox="0 0 6 4">
              <path id="Polygon_4" data-name="Polygon 4" d="M3,0,6,4H0Z" transform="translate(6 4) rotate(180)"
                fill="#fff"></path>
            </svg>

          </h3>
          <div :class="currentAccordion === 'shop' ? '!flex' : 'hidden'"
            class="md:flex flex-col tracking-wide space-y-2.5 lg:space-y-3 pt-4 md:pt-0 hidden">

            <a href="https://lifeboostcoffee.com/collections/light-roast" class="text-white link hr">
              Light Roast
            </a>

            <a href="https://lifeboostcoffee.com/collections/medium-roast" class="text-white link hr">
              Medium Roast
            </a>

            <a href="https://lifeboostcoffee.com/collections/dark-roast" class="text-white link hr">
              Dark Roast
            </a>

            <a href="https://lifeboostcoffee.com/collections/decaf-roast" class="text-white link hr">
              Decaf
            </a>

          </div>
        </div>

        <div class="w-full py-5 border-b border-gray-400 md:w-auto md:py-0 md:border-0">

          <h3 @click="toggleAccordion('lifeboost')"
            class="flex items-center justify-between text-base cursor-pointer lg:text-lg font-ww-medium md:cursor-default md:pb-6 accordion-button">
            Lifeboost
            <svg role="presentation" data-acco-button="lifeboost" class="block md:hidden"
              xmlns="http://www.w3.org/2000/svg" width="6" height="4" viewBox="0 0 6 4">
              <path id="Polygon_4" data-name="Polygon 4" d="M3,0,6,4H0Z" transform="translate(6 4) rotate(180)"
                fill="#fff"></path>
            </svg>

          </h3>
          <div :class="currentAccordion === 'lifeboost' ? '!flex' : 'hidden'"
            class="md:flex flex-col tracking-wide space-y-2.5 lg:space-y-3 pt-4 md:pt-0 hidden">

            <a href="https://lifeboostcoffee.com/pages/our-story" class="text-white link hr">
              Our Story
            </a>

            <a href="https://lifeboostcoffee.com/pages/how-its-made" class="text-white link hr">
              How It's Made
            </a>

            <a href="https://lifeboostcoffee.com/pages/subscribe-save" class="text-white link hr">
              Subscribe &amp; Save
            </a>

            <a href="https://lifeboostcoffee.com/blogs/lifeboost" class="text-white link hr">
              Lifeboost Blog
            </a>

            <a href="https://lifeboostcoffee.com/pages/brand-ambassadors" class="text-white link hr">
              Brand Ambassadors
            </a>

            <a href="https://lifeboostcoffee.com/pages/affiliate" class="text-white link hr">
              Affiliate
            </a>



          </div>
        </div>

        <div class="w-full py-5 border-b border-gray-400 md:w-auto md:py-0 md:border-0">

          <h3 @click="toggleAccordion('customer-care')"
            class="flex items-center justify-between text-base cursor-pointer lg:text-lg font-ww-medium md:cursor-default md:pb-6 accordion-button">
            Customer Care
            <svg role="presentation" data-acco-button="customer-care" class="block md:hidden"
              xmlns="http://www.w3.org/2000/svg" width="6" height="4" viewBox="0 0 6 4">
              <path id="Polygon_4" data-name="Polygon 4" d="M3,0,6,4H0Z" transform="translate(6 4) rotate(180)"
                fill="#fff"></path>
            </svg>

          </h3>
          <div :class="currentAccordion === 'customer-care' ? '!flex' : 'hidden'"
            class="md:flex flex-col tracking-wide space-y-2.5 lg:space-y-3 pt-4 md:pt-0 hidden">

            <a href="https://lifeboostcoffee.com/pages/contact-us" class="text-white link hr">
              Contact Us
            </a>

            <a href="https://lifeboostcoffee.com/pages/our-reviews" class="text-white link hr">
              Reviews
            </a>

            <a href="https://lifeboostcoffee.com/pages/shipping-and-delivery" class="text-white link hr">
              Shipping Policy
            </a>

            <a href="https://lifeboost-help-center.gorgias.help/en-US" class="text-white link hr" target="_blank"
              rel="noopener noreferrer">
              FAQ
            </a>


          </div>
        </div>

        <div class="w-full py-5 border-b border-gray-400 md:w-auto md:border-0 md:py-0">

          <h3 @click="toggleAccordion('legal')"
            class="flex items-center justify-between text-base cursor-pointer lg:text-lg font-ww-medium md:cursor-default md:pb-6 accordion-button">
            Legal
            <svg role="presentation" data-acco-button="legal" class="block md:hidden" xmlns="http://www.w3.org/2000/svg"
              width="6" height="4" viewBox="0 0 6 4">
              <path id="Polygon_4" data-name="Polygon 4" d="M3,0,6,4H0Z" transform="translate(6 4) rotate(180)"
                fill="#fff"></path>
            </svg>
          </h3>


          <div :class="currentAccordion === 'legal' ? '!flex' : 'hidden'"
            class="md:flex flex-col tracking-wide space-y-2.5 lg:space-y-3 pt-4 md:pt-0">
            <a href="https://lifeboostcoffee.com/pages/terms" class="text-white link hr">
              Terms of Use
            </a>

            <a href="https://lifeboostcoffee.com/pages/privacy" class="text-white link hr">
              Privacy Policy
            </a>
          </div>





        </div>

      </div>
      <div class="w-full pb-4 lg:w-4/12 xl:pr-9">
        <div
          class="flex flex-wrap items-center justify-center mx-auto text-center md:flex-nowrap lg:flex-wrap lg:justify-start md:text-left lg:pr-12 md:pr-0">

          <!--logo-->
          <a href="/"
            class="top-6 left-1/2 transform lg:translate-x-0 lg:mx-0 lg:static inline-block mb-6 xl:mb-5 2xl:mb-2.5"
            aria-label="Go to Home Page">



          </a>
          <!--newsletter-->

          <div class="max-w-xs">
            <svg class="md-max:mx-auto lg:mr-3 w-44 fill-white" alt="LifeboostCoffee Branding Logo HorizontalLogo"
              xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1580 580">
              <path
                d="M20.6 10.9C8.8 33.4 2.3 69.5 4.9 98.2c5.8 63.6 40.3 121.7 104.9 176.6 4 3.5 7.7 6 8.2 5.7 1.8-1.1 7-15.6 8.9-25.2 2.6-12.6 2.8-32.8.5-46.4-6-34.9-26.3-70.6-59.1-103.7-10.3-10.4-11.5-11.3-14.5-11-2.8.3-3.4.7-3.6 3.1-.3 2.5 1.4 4.6 12.5 16 30.7 31.5 48.5 62 55 94.5 2.7 13.3 2.4 36.9-.6 48.9-1.2 5.1-2.7 9.3-3.2 9.3-1.9 0-41-39.9-48.9-50-20-25.2-33.8-50.3-42.4-76.5-9.7-29.5-11.3-66.7-4-95.4 2.5-10 8.2-26.1 9.3-26.1 1.1 0 22 16.6 34.2 27 34.6 29.7 63.1 66.4 77.2 99.6 10.4 24.3 14.6 43.5 15.4 69.9.8 30.5-3.7 55.7-15.3 85-11.8 29.6-26 54.2-45.5 78.5-29 36.1-44 62.8-48.5 85.8-1.8 9.5-1.8 13.7.2 15.6 3.9 4 8.4-.1 8.4-7.5 0-19.2 16.2-49.3 48-88.8 6.5-8.1 13.9-17.9 16.4-21.9 2.6-4 4.8-7.2 5-7.2 3.1 0 20-3.8 27.4-6.1 36.8-11.7 62.4-36.9 73.5-72.4 8.4-26.8 8.1-63-.9-100.7-1.4-6.2-3.1-11.9-3.7-12.6-.6-.7-2.1-1.2-3.5-1-4.5.5-4.8 2.6-1.8 15.9 4.1 19.1 5.6 30 6.3 46.9.6 17-.5 29.4-3.8 42.9-8.5 34.3-32.7 60-67.3 71.6-8.2 2.8-20.9 5.6-20.4 4.6.2-.3 3.3-6.5 6.9-13.6 45.9-90.3 36.5-174.7-28.2-251.9C91 57.4 66.1 34.5 39.8 14.9c-16.7-12.4-14.9-12.1-19.2-4z">
              </path>
              <path
                d="M179.5 74.8c-12.6 3.8-29.9 14.4-31.2 19.1-.4 1.8 0 2.9 1.6 4.2 2.6 2.1 4 1.7 10.1-3 10.8-8.3 27.5-14 36.9-12.6 11.6 1.6 19.9 8.6 27.3 23.1 3.9 7.7 4.6 8.4 7.8 9 17.1 3 50.4 9.4 50.7 9.7.7.7-4.7 1.5-30.7 4.2-23.9 2.5-26 2.9-33 6-10.3 4.6-17.3 6.5-24.3 6.5-5.3 0-6.2-.3-9.2-3.3-5.6-5.6-6.1-17.5-.8-21.7 5.7-4.4 12.5-3.3 14.9 2.6 1.7 4 4.1 5.5 7.2 4.3 1.6-.6 2.2-1.6 2.2-3.9 0-7.5-6.9-14.1-15.5-14.8-6.7-.5-11.3 1-15.5 5.1-4.4 4.3-6.2 8.9-6.2 15.8 0 12.8 5.7 21.5 16 24.5 7.5 2.2 17.1.8 29.1-4.2 11.8-4.9 12.5-5 40.1-8 29.3-3.1 47.1-5.9 51.1-7.9 2.2-1.2 2.9-2.2 2.9-4.6 0-2.4-.6-3.3-3.2-4.4-4.2-1.7-25.6-6.3-51.9-11.1l-20.6-3.8-3.4-6.4c-5.1-9.6-13.7-18.5-21.6-22.4-5.7-2.8-7.8-3.3-15.7-3.5-6.5-.2-10.8.2-15.1 1.5zM948.7 195.1c-34.4 4.6-58 29.2-66.9 69.4-2.5 11.5-3.6 42.1-1.9 54.7 4 29.9 15.4 52.5 33.5 66.2 21 15.9 45.9 20 70.4 11.7 11.8-4.1 18.5-8.4 28.8-18.6 8-8 9.6-10.3 14.7-20.5 9.6-19.5 13.5-40.6 12.4-67.4-1.4-34.7-11-59.6-29.8-77-15.5-14.3-39.2-21.5-61.2-18.5zm25.8 16.4c12 3.2 22.4 10.9 29.4 22 10.3 16.3 14.4 35 14.4 65-.1 27.5-2.9 43.2-10.7 59-7.3 14.9-19 24.4-33.4 27.4-7.5 1.6-23.6 1.3-31.1-.4-24.8-5.9-40.2-29.3-44-66.9-5.6-55.4 12.2-97.2 45-106 7.2-2 23-2 30.4-.1zM1123.5 195c-19.5 2.4-36.6 11.7-49.1 26.8-13.7 16.6-21 39.7-22.1 69.7-1.2 32 5.3 58.6 19.1 77.8 20.3 28.5 57.9 39.5 90.6 26.5 20-8 36.2-24.8 44.5-46.3 5.8-14.9 7.6-24.7 8.2-45.2.8-26.3-2-44.3-9.7-62.5-13.8-32.4-46.3-51-81.5-46.8zm25 16.4c23.3 6.2 37.2 24.8 43.1 57.6 2.3 12.8 2.4 45.5.1 59-5.5 32.3-18.9 50.6-41.2 56.5-7.6 1.9-25 1.9-33.3 0-9.3-2.2-16-6-22.9-13.1-14-14.3-20.3-36.8-20.3-72.9 0-25.3 2.5-40.8 9-55.2 7.4-16.4 19.8-27.6 35.1-31.7 6.9-1.9 23.9-2 30.4-.2zM1271.2 197c-20.8 5.6-34.2 17.8-39.6 35.9-2.1 7.2-2.1 23 0 30.2 5.6 18.9 16.1 27.1 55.7 43.4 25.6 10.6 35.1 19.1 39.3 35.5 3.2 12.6.3 24.8-8.1 33.9-10.1 10.9-20.4 14.6-40.5 14.5-19.4 0-34-3.9-46.7-12.4l-3.3-2.2v5c0 5.9 1.4 7.2 12.4 12.2 12.6 5.8 21.5 7.5 38.6 7.5 14.2-.1 16.2-.3 23.5-2.8 21.1-7.1 36.2-21.9 41-40.2.8-3.3 1.5-9.6 1.5-14 0-15.4-5.1-27.7-15.5-37.3-8.4-7.8-14.4-11.1-34.4-19.2-26.8-10.9-38.3-18.6-44.6-30.2-2.5-4.6-3-6.6-3.3-15.1-.4-9.4-.3-10.1 2.7-16.2 7.1-14.5 23-21.7 44.2-20.1 13.1 1 22 3.6 36.2 10.4.4.2.7-1.9.7-4.8v-5.1l-6.4-2.9c-11.4-5.2-20-7.1-33.6-7.6-10.3-.3-13.8-.1-19.8 1.6zM750.8 200.7l-7.8.4V394h28c15.5 0 32.4-.5 37.7-1.1 18.9-2.1 36.3-8.7 46.4-17.8 15.1-13.5 19.3-38.1 9.7-58-5-10.4-18.8-20-34.8-24-5.7-1.5-7-2.1-5.5-2.7 18-6.7 30.1-17.3 35.6-31.1 1.9-4.8 2.3-7.7 2.4-16.8 0-9.4-.3-11.7-2.4-16.2-3-6.8-11.3-14.6-19.5-18.4-12.2-5.7-21.7-7-53.6-7.3-15.7-.2-32-.1-36.2.1zm66.7 12.7c16.3 4.5 23.3 15.4 22.3 34.7-.9 17.5-9.5 28.5-26.9 34.3-8.7 2.9-22.6 4.6-37.4 4.6H765v-76.2l23.3.5c17.3.3 24.7.9 29.2 2.1zm-4.3 86.4c23.9 6.4 35 21.6 33.5 46.2-.7 11.9-2.9 17.3-9.6 24.1-9.8 9.7-22.8 12.9-53.2 12.9H765V296.7l20.3.6c15.8.4 21.8.9 27.9 2.5zM1516 203c0 2.9.1 3 5 3h5v26h7v-26h5c4.9 0 5-.1 5-3v-3h-27v3zM1547 215.9V232h6.9l.3-8.1.3-8.1 3.4 4.6c1.9 2.5 4 4.6 4.5 4.6.6 0 3-2.1 5.3-4.7l4.2-4.8.1 8.2v8.3h6v-16c0-9.9-.4-16-1-16-.5 0-4 3.8-7.6 8.5l-6.7 8.5-6.4-8.3c-3.5-4.5-7.1-8.3-7.9-8.5-1.2-.3-1.4 2.2-1.4 15.7zM294 297.5V394h99v-11h-77V201h-22v96.5zM428 297.5V394h22V201h-22v96.5zM490 297.5V394h22v-96h68v-10l-33.7-.2-33.8-.3-.3-38.3-.2-38.2h76v-10h-98v96.5zM616 297.5V394h98v-11h-76v-85h68v-10h-68v-77h76v-10h-98v96.5zM1353 206v5h59v183h22V211h60v-10h-141v5zM844.5 489.4c-6.9 3.1-9.5 8.9-9.5 21.2v8.4h-8v8h8v48h9v-48h14v-8h-14v-8.6c0-8.1.1-8.7 2.9-11.5 2.6-2.5 3.7-2.9 8.6-2.9h5.6l-.3-3.8-.3-3.7-6.5-.2c-3.8-.2-7.7.3-9.5 1.1zM887.5 489.4c-6.9 3.1-9.5 8.9-9.5 21.2v8.4h-8v8h8v48h9v-48h14v-8h-14v-8.6c0-8.1.1-8.7 2.9-11.5 2.6-2.5 3.7-2.9 8.6-2.9h5.6l-.3-3.8-.3-3.7-6.5-.2c-3.8-.2-7.7.3-9.5 1.1zM693.4 519.8c-19.6 6.8-25.7 31.6-11.7 47.2 10.7 11.9 30.5 12.7 41.3 1.5 2.8-2.9 3.1-3.6 2-5-3.1-3.7-5-3.9-8.4-.7-4.5 4.3-6.8 5.2-13.3 5.2-10.8 0-18.9-7.4-20-18.2-.7-6.8.8-11.7 5-16.5 7.7-8.8 19.4-9.6 28.3-1.9l4 3.5 3-2.4 2.9-2.4-4-4c-7.2-7.5-18.6-9.9-29.1-6.3zM767.2 519.8c-11.2 4-18.1 13.2-19 25.1-2.3 32.7 42 44 55.6 14.2 4.8-10.4 2.9-22.7-4.7-31.4-7.2-8.2-21.3-11.7-31.9-7.9zm21.2 9.9c5.9 4.2 8.6 9.4 8.6 17.1 0 7.8-1.6 11.7-6.8 16.4-4.5 4.1-8.8 5.3-16.3 4.6-13.7-1.3-21.1-17.6-14.1-30.9 2.2-4.3 3.8-5.9 8.2-8.2 4.7-2.5 6.3-2.8 10.9-2.3 3.8.3 6.8 1.4 9.5 3.3zM938.2 519.8c-7.4 2.7-12.5 7.4-16.3 15.2-3.2 6.5-3.2 17.6 0 24.7 5.7 12.7 20.5 19.5 34.4 15.8 5.5-1.4 14.7-6.7 14.7-8.3-.1-.4-1.1-2-2.4-3.5-2.2-2.8-2.2-2.8-4.7-.9-9.2 7.2-23.5 7-30-.4-2.4-2.8-4.9-8-4.9-10.4 0-2 .5-2 22-2h22v-6.5c0-3.7-.7-8.2-1.6-10.3-5-12-20-18.1-33.2-13.4zm17.8 8.5c4.5 2.3 8 7.4 8 11.4v2.3h-17.5c-13.7 0-17.5-.3-17.5-1.3 0-.7 1.3-3.3 2.9-5.8 5.3-8.4 15.5-11.2 24.1-6.6zM1015.6 519.6c-6.7 2.1-14.7 10.2-17 17.2-5.9 17.7 2.8 34.3 20.5 38.8 7.7 2 16.2.7 22.8-3.3 6.3-4 7.1-5.6 4.2-8.7l-2.3-2.4-4.5 3.1c-3.8 2.7-5.5 3.2-11.8 3.5-6.6.4-8 .1-11.9-2.2-4.8-2.8-8.2-7.4-9.2-12.5l-.6-3.1h44.1l.6-3.4c1-5.3-1.2-14.1-4.8-18.8-6.3-8.2-19.1-11.7-30.1-8.2zm17.4 8.6c4.5 2.3 7.2 5.9 8.4 11l.6 2.8h-36l1.5-3.7c2.1-5 5.2-8.2 10-10.4 5.4-2.5 10.2-2.4 15.5.3z">
              </path>
            </svg>

            <p class="pt-6 text-sm leading-5">Helping You Achieve the Healthiest, Tastiest Cup of
              Coffee Possible Using Sustainable Farming &
              Protecting Our Wildlife</p>
          </div>

        </div>
      </div>
    </div>
    <!--footer bottom -->
    <div
      class="relative flex flex-wrap items-center justify-between px-5 pt-3 mx-auto max-w-screen-2xl md:px-7 lg:px-14 xl:px-20 2xl:px-12 lg:pt-4">
      <div
        class="flex flex-wrap items-center justify-center w-full mb-6 text-xs lg:w-auto lg:justify-start lg:text-sm lg:mb-0 md:space-x-12">
        <p class="block w-full mb-3 text-center md:w-auto md:mb-0"
          :aria-label="new Date().getFullYear() + '© Lifeboost Group Inc.'">
          {{ new Date().getFullYear() }} © Lifeboost Group Inc.
        </p>

        <a href="https://lifeboostcoffee.com/pages/privacy"
          class="block w-1/2 text-center text-white md:w-auto hover:text-lifeboost-red" aria-label="Privacy Policy">
          Privacy Policy</a>

        <a href="https://lifeboostcoffee.com/pages/terms"
          class="block w-1/2 text-center text-white md:w-auto hover:text-lifeboost-red"
          aria-label="Terms &amp; Conditions">Terms &amp; Conditions</a>



      </div>
      <div class="flex flex-wrap items-center justify-center w-full space-x-3 text-sm lg:w-auto lg:justify-end">


        <a href="https://www.facebook.com/lifeboostcoffee/" target="_blank" rel="nofollow" class="hover:opacity-75"
          aria-label="Facebook Page">


          <svg role="presentation" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
            width="20" height="20" viewBox="0 0 20 20">
            <defs>
              <clipPath id="clip-path">
                <rect id="Rectangle_523" data-name="Rectangle 523" width="20" height="20" fill="#fff" stroke="#707070"
                  stroke-width="1"></rect>
              </clipPath>
            </defs>
            <g id="Mask_Group_7" data-name="Mask Group 7" clip-path="url(#clip-path)">
              <g id="_001-facebook-logo" data-name="001-facebook-logo" transform="translate(0)">
                <path id="Facebook__x28_alt_x29_"
                  d="M20.022,3.337A3.459,3.459,0,0,0,16.685,0H3.337A3.459,3.459,0,0,0,0,3.337V16.685a3.459,3.459,0,0,0,3.337,3.337h6.674V12.458H7.564V9.121h2.447v-1.3c0-2.242,1.684-4.262,3.754-4.262h2.7V6.9h-2.7c-.3,0-.64.358-.64.9V9.121h3.337v3.337H13.126v7.564h3.56a3.459,3.459,0,0,0,3.337-3.337Z"
                  fill="#fff"></path>
              </g>
            </g>
          </svg>



        </a>


        <a href="https://www.instagram.com/lifeboostcoffee/" target="_blank" rel="nofollow" class="hover:opacity-75"
          aria-label="Instagram Page">


          <svg role="presentation" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
            width="20" height="20" viewBox="0 0 20 20">
            <defs>
              <clipPath id="clip-path">
                <rect id="Rectangle_524" data-name="Rectangle 524" width="20" height="20" transform="translate(-0.443)"
                  fill="#fff" stroke="#707070" stroke-width="1"></rect>
              </clipPath>
            </defs>
            <g id="Mask_Group_8" data-name="Mask Group 8" transform="translate(0.443)" clip-path="url(#clip-path)">
              <g id="_002-instagram" data-name="002-instagram" transform="translate(0)">
                <g id="Group_3428" data-name="Group 3428">
                  <g id="Group_3427" data-name="Group 3427">
                    <path id="Path_630" data-name="Path 630"
                      d="M13.765,0H6.257A6.258,6.258,0,0,0,0,6.257v7.508a6.258,6.258,0,0,0,6.257,6.257h7.508a6.258,6.258,0,0,0,6.257-6.257V6.257A6.258,6.258,0,0,0,13.765,0Zm4.38,13.765a4.385,4.385,0,0,1-4.38,4.38H6.257a4.385,4.385,0,0,1-4.38-4.38V6.257a4.385,4.385,0,0,1,4.38-4.38h7.508a4.385,4.385,0,0,1,4.38,4.38Z"
                      fill="#fff"></path>
                  </g>
                </g>
                <g id="Group_3430" data-name="Group 3430" transform="translate(5.006 5.006)">
                  <g id="Group_3429" data-name="Group 3429">
                    <path id="Path_631" data-name="Path 631"
                      d="M11.256,6.25a5.006,5.006,0,1,0,5.006,5.006A5.006,5.006,0,0,0,11.256,6.25Zm0,8.134a3.128,3.128,0,1,1,3.128-3.128A3.133,3.133,0,0,1,11.256,14.384Z"
                      transform="translate(-6.25 -6.25)" fill="#fff"></path>
                  </g>
                </g>
                <g id="Group_3432" data-name="Group 3432" transform="translate(14.725 3.963)">
                  <g id="Group_3431" data-name="Group 3431">
                    <circle id="Ellipse_44" data-name="Ellipse 44" cx="0.667" cy="0.667" r="0.667" fill="#fff"></circle>
                  </g>
                </g>
              </g>
            </g>
          </svg>



        </a>



      </div>
    </div>
  </div>

</template>

<script setup>
// Reactive state to keep track of the current open accordion
const currentAccordion = ref('');

// Function to toggle accordion
function toggleAccordion(accordionName) {
  if (currentAccordion.value === accordionName) {
    // If the same accordion is clicked, close it
    currentAccordion.value = '';
  } else {
    // Open the clicked accordion
    currentAccordion.value = accordionName;
  }
}

defineBuilderComponent({
  friendlyName: 'Main Footer'
})
</script>

<style lang="postcss" scoped>
.link.hr:hover {
  @apply text-lifeboost-red-400
}

.link.hr {
  @apply lg:text-sm lg:leading-5 text-xs leading-4
}
</style>